<template>
  <div class="app-container">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Connect with LINE</v-card-title>
        <v-card-text>Connect with LINE to get Notify</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="redirectToLine">Connect</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <main class="app-body">
      <router-view/>
    </main>

    <v-app-bar fixed bottom dark height="60">
      <template v-slot:default>
        <v-tabs
          class="no-slider"
          height="60"
          slider-size="5"
          slider-color="slider"
          centered
          center-active
        >
          <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.path" @click="tab.click">
            <div class="tab-content">
              <v-badge color="red" overlap :value="tab.path === 'alert' && $store.state.$user.unread_notifications > 0">
                <template v-slot:badge>
                  {{ $store.state.$user.unread_notifications < 100 ? $store.state.$user.unread_notifications : '99+' }}
                </template>
                <v-img class="tab-img" :src="tab.img" max-height="24" max-width="24"/>
              </v-badge>
              {{ tab.name }}
            </div>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
  import Api from '../providers/Api'
  import Permissions from './Permissions'

  export default {
    data() {
      return {
        tabs: [
          {
            name: 'Home',
            path: 'home',
            img: require('../assets/tabs/home.svg'),
            permissions: [],
            click: () => {
            },
          },
          {
            name: 'Alert',
            path: 'alert',
            img: require('../assets/tabs/alert.svg'),
            permissions: [],
            click: () => {
            },
          },
          {
            name: 'GIS',
            path: 'gis',
            img: require('../assets/tabs/gis.svg'),
            permissions: [],
            click: () => {
            },
          },
          // {
          //   name: 'Report',
          //   path: 'report',
          //   img: require('../assets/tabs/report.svg'),
          //   permissions: [],
          // },
          {
            name: 'Graph',
            path: 'graph',
            img: require('../assets/tabs/graph.svg'),
            permissions: [],
            click: () => {
            },
          },
          // {
          //   name: 'DMA Planner',
          //   path: 'planner',
          //   img: require('../assets/tabs/planner.svg'),
          //   permissions: [],
          // },
          {
            name: 'Logout',
            path: '#',
            img: require('../assets/tabs/logout.svg'),
            permissions: [],
            click: () => {
              this.logout()
            },
          },
        ],
        dialog: false,
        interval_api_me: null,
      }
    },
    beforeDestroy() {
      clearInterval(this.interval_api_me)
    },
    created() {
      if (!this.checkLogin()) {
        this.$store.state.intended = this.$route.fullPath
        this.$router.push('/login')
      } else {
        this.getMe()
        this.interval_api_me = setInterval(() => {
          this.getMe();
        }, 50000)
        if (this.$store.state.need_register_line) {
          this.dialog = true
        }
      }
    },

    methods: {
      getMe() {
        this.get('/api/me')
          .then(({data}) => {
            this.$store.state.$user = data.data
          })
          .catch(() => {
          })
      },

      redirectToLine() {
        let line_route = `/line/request-authorize?token=${this.getToken().access_token}`

        window.location.href = process.env.NODE_ENV === 'production'
          ? line_route
          : (
            typeof process.env.VUE_APP_BASE_URL !== 'undefined'
              ? process.env.VUE_APP_BASE_URL + line_route
              : `http://127.0.0.1:8000${line_route}`
          )
      },

      closeDialog() {
        this.dialog = false

        this.$store.state.need_register_line = false
      },

      logout() {
        this.post('/api/logout');

        this.logOut();
      },

      // hasPermissions (permissions) {
      //   return permissions.length === 0 || _.intersection(permissions, this.$store.state.$user.permissions).length !== 0
      // },
      //
      // setPermission (permission) {
      //   this.page_permissions = permission
      // },
    },

    mixins: [
      Api,
    ],
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .app-body {
    color: white;
    max-height: calc(100vh - 60px);
    max-width: 100vw;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    background-color: transparent !important;
  }

  .no-slider {
    .v-slide-group__wrapper {
      background-color: #1B2431;
    }

    .v-slide-group__prev {
      display: none !important;
    }

    .v-tabs-slider-wrapper {
      top: 0 !important;

      .slider {
        background: linear-gradient(90deg, #6BD1ED 0%, #0054A4 100%);
      }
    }

    .v-tab {
      text-transform: none !important;
      padding-top: 5px;

      & .tab-content {
        display: grid;
        z-index: 9;
      }

      & .tab-img {
        margin: 0 auto;
      }

      &.v-tab--active {
        background-color: #273142;
      }
    }
  }
</style>
